
namespace RioERP.Reports {

    @Serenity.Decorators.registerClass()
    export class OrderOutstandingReportGrid extends Serenity.EntityGrid<OrderOutstandingReportRow, any> {
        protected getColumnsKey() { return OrderOutstandingReportColumns.columnsKey; }
        protected getDialogType() { return OrderOutstandingReportDialog; }
        protected getIdProperty() { return OrderOutstandingReportRow.idProperty; }
        protected getInsertPermission() { return OrderOutstandingReportRow.insertPermission; }
        protected getLocalTextPrefix() { return OrderOutstandingReportRow.localTextPrefix; }
        protected getService() { return OrderOutstandingReportService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }

        protected getButtons() {
            var buttons = super.getButtons();
            buttons.splice(0, 3);
            buttons.push(Common.ExcelExportHelper.createToolButton({
                grid: this,
                title: 'Export',
                service: OrderOutstandingReportService.baseUrl + '/ListExcel',
                onViewSubmit: () => this.onViewSubmit(),
                separator: true
            }));

            return buttons;

        }
    }
}